import type { IconName } from '../components/Icon';
/**
 * How a material FAMILY looks, app-wide: `token` in amber for filament,
 * `water_drop` in purple for resin. A piece, a spool, a printer and a default
 * €/kg of the same family must read as relatives, so there is ONE table.
 *
 * `chip` is the soft tile (icon on a tinted background) used for badges and
 * headers; `text` is the bare icon colour for inline use.
 */
export type MaterialFamily = 'filament' | 'resin';

export interface MaterialFamilyLook {
    icon: IconName;
    chip: string;
    text: string;
}

export const MATERIAL_FAMILY_LOOK: Record<MaterialFamily, MaterialFamilyLook> = {
    filament: {
        icon: 'token',
        chip: 'bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-300',
        text: 'text-amber-600 dark:text-amber-400',
    },
    resin: {
        icon: 'water_drop',
        chip: 'bg-purple-100 text-purple-700 dark:bg-purple-900/30 dark:text-purple-400',
        text: 'text-purple-600 dark:text-purple-400',
    },
};
